import svg4everybody from 'svg4everybody';
import $ from "jquery";

export default function() {
    svg4everybody();


    // Contact Form 7 v5.3.0
    const wpcf7 = window.wpcf7;
    window.jQuery = $;
}
